var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"prepend-inner-icon":"mdi-map-marker","autocomplete":"cc-country","items":_vm.items,"rules":[_vm.rules.required],"disabled":_vm.disabled,"outlined":""},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }